import { render, staticRenderFns } from "./deliveryRoute.vue?vue&type=template&id=bd1809cc&scoped=true&"
import script from "./deliveryRoute.vue?vue&type=script&lang=js&"
export * from "./deliveryRoute.vue?vue&type=script&lang=js&"
import style0 from "./deliveryRoute.vue?vue&type=style&index=0&id=bd1809cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1809cc",
  null
  
)

export default component.exports